import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Calendar, User, LayoutDashboard, Bot, type LucideIcon } from 'lucide-react';
import { cn } from '../../lib/utils';

// Haptic feedback simulator
const triggerHaptic = () => {
    if (typeof window !== 'undefined' && window.navigator && window.navigator.vibrate) {
        window.navigator.vibrate(50); // Light haptic feedback
    }
};

const NavButton = ({ 
    icon: Icon, 
    label, 
    isActive,
    onClick,
}: { 
    icon: LucideIcon;
    label: string; 
    isActive: boolean;
    onClick: () => void;
}) => {
    return (
        <button
            type="button"
            onClick={onClick}
            className={cn(
                'flex min-h-16 min-w-14 flex-1 select-none flex-col items-center justify-center gap-1 rounded-lg px-1 text-slate-500 transition-colors duration-150 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ruby-500 dark:text-slate-400',
                isActive && 'bg-ruby-50 text-ruby-700 dark:bg-ruby-500/15 dark:text-ruby-300'
            )}
            aria-current={isActive ? 'page' : undefined}
        >
            <Icon size={22} strokeWidth={isActive ? 2.4 : 2} aria-hidden="true" />
            <span className="max-w-full truncate text-[11px] font-semibold leading-none">{label}</span>
        </button>
    );
};

export const RiderBottomNav: React.FC = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const isActiveCurrent = (path: string) => location.pathname === path;

    const navigateTo = (path: string) => {
        triggerHaptic();
        navigate(path);
    };

    return (
        <div className="pointer-events-none fixed inset-x-0 bottom-0 z-50">
            <nav className="rider-tab-bar pointer-events-auto mx-auto max-w-md" aria-label="Navegacion del repartidor">
                <div className="flex min-h-[68px] items-stretch gap-1 px-2">
                    <NavButton onClick={() => navigateTo('/rider/dashboard')} isActive={isActiveCurrent('/rider/dashboard')} icon={LayoutDashboard} label="Inicio" />
                    <NavButton onClick={() => navigateTo('/rider/schedule')} isActive={isActiveCurrent('/rider/schedule')} icon={Calendar} label="Agenda" />
                    <NavButton onClick={() => navigateTo('/rider/advisor')} isActive={isActiveCurrent('/rider/advisor')} icon={Bot} label="Asesor" />
                    <NavButton onClick={() => navigateTo('/rider/profile')} isActive={isActiveCurrent('/rider/profile')} icon={User} label="Perfil" />
                </div>
            </nav>
        </div>
    );
};
